import { settingsIcon } from "@/components/icons/SVGIcons";

// LQC-1728 — cog icon as the column heading for the trade-wide settings column.
// Icon-only so the column stays 20px wide; `headerTooltip` on the colDef still
// provides the "Trade-wide settings" label on hover.
const TradeWideSettingsHeader = () => {
  return (
    <div
      data-testid="TradeWideSettingsHeaderContainer"
      id="TradeWideSettingsHeaderContainer"
      className="flex h-full w-full items-center justify-center text-gray-500 dark:text-gray-400 [&>svg]:h-[18px] [&>svg]:w-[18px]"
    >
      {settingsIcon}
    </div>
  );
};

export default TradeWideSettingsHeader;
